import axios from "../../../../../axios";
import React from "react";
import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import "../../Published/Published_Q_list/publishedQListPreRead.css";
import PdfQType from "./PublishQuestionType/PdfType/PdfQType";
import CompletedSlist from "./CompletedSlist";
import { Popup } from "semantic-ui-react";
import { Book } from "lucide-react";
export default function PublishedQListPreRead({ publishPre_id, onClose }) {
  //Added this state by kuldeep
  const [publicData, setPublicData] = useState({
    publihPreRed: [],
    preCompleteSList: [],
  });

  const navigate = useNavigate();
  const { publihPreRed, preCompleteSList } = publicData;
  //Add loader
  const [isGettingData, setIsGettingData] = useState(true);
  const state = useLocation();
  useEffect(() => {
    const getCreatedPreRed = async () => {
      const preRead_id = state?.state?.publishPre_id || publishPre_id;
      try {
        const res = await axios.get(
          `/api/v1/homework/preRead/getById/${preRead_id}`,
        );

        setIsGettingData(false);
        const preCompleteSList = await axios.get(
          `/api/v1/homework/preReadId/${preRead_id}/studentList/get?status=completed&isOnlyList=true`,
        );
        res &&
          preCompleteSList &&
          setPublicData({
            publihPreRed: res.data.data,
            preCompleteSList: preCompleteSList.data.data,
          });
        setIsGettingData(false);
      } catch (error) {
        setIsGettingData(true);
      }
    };
    getCreatedPreRed();
  }, []);

  const myList = [preCompleteSList];

  const totalLength = myList
    .map((array) => array.length)
    .reduce((sum, length) => sum + length, 0);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{
        backgroundColor: "rgba(0,0,0,0.4)",
        zIndex: 9999,
      }}
    >
      <div
        className="bg-white rounded shadow "
        style={{
          width: "90%",
          maxWidth: "650px",
          maxHeight: "800px",
          overflowY: "auto",
          backgroundColor: "#FFF6EF",
        }}
      >
        {!isGettingData ? (
          <>
            {/* Header */}
            <div
              className="p-4"
              style={{ backgroundColor: "#fdefe4", height: "120px" }}
            >
              <div className="d-flex justify-content-between align-items-center mb-3 ">
                <div className="d-flex align-items-center gap-2">
                  <Book size={20} />
                  <h5 className="fw-bold m-0">{publihPreRed?.name}</h5>
                </div>
                <button
                  className="btn btn-sm btn-outline-secondary rounded-circle"
                  onClick={() => {
                    if (typeof onClose === "function") {
                      onClose();
                      return;
                    }
                    navigate("/liveSession", {
                      state: {
                        supplement_id: state?.state?.supplement_id,
                        standardsName: state?.state?.standard,
                        sectionName: state?.state?.section,
                      },
                      replace: true,
                    });
                  }}
                >
                  ✕
                </button>
              </div>

              {/* Subject + Status + Members */}
              <div className="d-flex align-items-center mb-3 gap-2 flex-wrap">
                <span className="badge bg-light text-dark d-flex align-items-center">
                  📘 {publihPreRed?.subject_id?.name}
                </span>
                <span className="badge bg-warning text-white">Published</span>

                <div className="d-flex align-items-center ms-2">
                  <img
                    src="/images/memberListIcon.png"
                    alt=""
                    className="border rounded-circle me-1"
                    style={{ width: "36px", height: "36px" }}
                    onClick={() => {}}
                  />
                  <Popup
                    trigger={
                      <div
                        className="d-flex align-items-center justify-content-center border rounded px-2 py-1"
                        style={{ cursor: "pointer" }}
                      >
                        {totalLength || 0}
                      </div>
                    }
                    content={
                      <CompletedSlist preCompleteSList={preCompleteSList} />
                    }
                    position="bottom right"
                    on="click"
                    positionFixed
                    style={{ zIndex: 10000 }}
                  />
                </div>
              </div>
            </div>

            <div className="p-4" style={{ backgroundColor: "#f3f3f3" }}>
              {/* Description */}
              <p
                className="text-muted"
                style={{ fontSize: "0.95rem", wordBreak: "break-all" }}
              >
                {publihPreRed?.description}
              </p>

              <hr />

              {/* Attachments */}
              {publihPreRed?.attachments?.length > 0 && (
                <div className="col-12">
                  <h6 className="fw-semibold mt-4 mb-2">📎 Shared Files</h6>
                  <div className="row">
                    {publihPreRed.attachments.map((attachment, idx) => (
                      <div className="col-12 col-sm-6 col-md-4 mb-3 " key={idx}>
                        <PdfQType
                          attachData={publihPreRed}
                          attachment={attachment}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
        )}
      </div>
    </div>
  );
}
